import { Check } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ORGANIZER_LAYOUTS } from "./layout-registry";

interface Props {
  selected: string;
  onChange: (id: string) => void;
}

export function LayoutPicker({ selected, onChange }: Props) {
  const { t } = useTranslation();
  const original = ORGANIZER_LAYOUTS.filter((l) => l.tier === "original" || l.id === "default");
  const premium = ORGANIZER_LAYOUTS.filter((l) => l.tier === "premium");

  return (
    <div className="space-y-4">
      <Group title={t("themes.layoutGroupClassic")} items={original} selected={selected} onChange={onChange} />
      <Group title={t("themes.layoutGroupPremium")} items={premium} selected={selected} onChange={onChange} />
    </div>
  );
}

function Group({
  title,
  items,
  selected,
  onChange,
}: {
  title: string;
  items: typeof ORGANIZER_LAYOUTS;
  selected: string;
  onChange: (id: string) => void;
}) {
  const { t } = useTranslation();
  return (
    <div className="space-y-2">
      <h4 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">{title}</h4>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
        {items.map((l) => {
          const active = selected === l.id;
          const hasEditor = Boolean(l.editor);
          return (
            <button
              key={l.id}
              type="button"
              onClick={() => onChange(l.id)}
              className={`relative flex flex-col items-start gap-1 rounded-2xl border p-3 text-left transition-all cursor-pointer min-h-[80px] ${
                active ? "border-primary bg-primary/5 ring-2 ring-primary/20" : "border-border hover:border-primary/40 hover:bg-muted/40"
              }`}
            >
              <span className="text-sm font-semibold leading-tight">{t(`themes.layoutNames.${l.id}`, l.label)}</span>
              <span className="text-[11px] text-muted-foreground">
                {hasEditor ? t("themes.layoutStatusEditable") : l.id === "default" ? t("themes.layoutStatusClassic") : t("themes.layoutStatusPreview")}
              </span>
              {active && (
                <span className="absolute top-2 right-2 flex h-5 w-5 items-center justify-center rounded-full bg-primary text-white">
                  <Check className="h-3 w-3" />
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
